(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-template"]) return;
  try {
    
  const tocElt = document.querySelector('.ArticleBody_tocList');
  const articleTitlesEls = document.querySelectorAll('.BlogArticleTitle');

  articleTitlesEls.forEach((articleTitlesElt) => {
    const tocItemElt = document.createElement('li');

    tocItemElt.textContent = articleTitlesElt.innerText;
    tocItemElt.classList.add('ArticleBody_tocItem');
    tocItemElt.addEventListener('click', () => {
      articleTitlesElt.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    });
    tocElt.append(tocItemElt);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carte-home-anglais"]) return;
  try {
    
    (function (){
            var attrSelector = $(window).width() > 589 ? 'data-src' : 'data-mobile-src';
            $('.js-home-video').each(function () {
                if($(this).attr('data-mobile-src')) {
                    $(this).attr('src', $(this).attr(attrSelector))
                } else {
                    $(this).attr('src', $(this).attr('data-src'))
                }
            })
    })()
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carte-home-cena"]) return;
  try {
    
    (function (){
            var attrSelector = $(window).width() > 589 ? 'data-src' : 'data-mobile-src';
            $('.js-home-video').each(function () {
                if($(this).attr('data-mobile-src')) {
                    $(this).attr('src', $(this).attr(attrSelector))
                } else {
                    $(this).attr('src', $(this).attr('data-src'))
                }
            })
    })()
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carte-home"]) return;
  try {
    
        (function (){
            var attrSelector = $(window).width() > 589 ? 'data-src' : 'data-mobile-src';
            $('.js-home-video').each(function () {
                if($(this).attr('data-mobile-src')) {
                    $(this).attr('src', $(this).attr(attrSelector))
                } else {
                    $(this).attr('src', $(this).attr('data-src'))
                }
            })
        })()
        
  } catch(e) { console.error(e); }
})();
})();
